module.exports = __webpack_public_path__ + "img/comment.d4d9c799.svg";